module.exports = __webpack_public_path__ + "static/media/Gilroy-Black.19d313b9.otf";